import { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { api } from '@/lib/api';
import { getBranding } from '@/lib/branding';

// Thin global banner shown to every user while a server update is in progress.
// Polls the unauthenticated maintenance endpoint so it also works on the login
// shell; silent on any error so it never blocks the UI.
export default function MaintenanceBanner() {
  const [m, setM] = useState(null);
  const appName = getBranding()?.app_name || 'The app';

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try { const r = await api.getMaintenanceStatus(); if (alive) setM(r); } catch { /* ignore */ }
    };
    poll();
    const id = setInterval(poll, 15000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!m?.active) return null;
  return (
    <div className="px-4 py-2.5 bg-amber-600 flex items-center gap-2 text-sm text-white font-medium" data-testid="maintenance-banner">
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span>{m.message || `${appName} is updating. Some features may be briefly unavailable.`}</span>
    </div>
  );
}
